<template>
    <ob-modal2 :show.sync="isModalOpen" :backdrop="false">
        <template slot="modal-title" v-if="!showClipBoard">
            Add Project
        </template>
        <template slot="modal-title" v-else>
                        Add Project From ClipBoard
        </template>
        <template slot="modal-body">
            <div class="ob_pop-container" v-if="!showClipBoard">
                <div class="col-md-6 offset-0 popup_requiremt">
                    <a><img @click="openCreateProject" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/create.svg`"></a>

                    <h2><a @click="openCreateProject">Manually Create the Project</a></h2>
                    Use this option to manually fill in<br> the details to create Project.
                </div>
                <div class="col-md-6 ob_pop-container_clip">
                    <a @click="showClipBoard = true" class="Clipboard_img"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/clipboard.svg`"></a>
                    <h2><a class="Clipboard_img" @click="showClipBoard = true">Paste from Clipboard</a></h2>
                     Use this option to automatically <br>create requirement by copying<br> the details from email.

                </div>
                <div class="clearfix"></div>
            </div>
            <div v-else>
                <div class="popup_requiremt-clip">
                    <span>Copy paste your Project Details in our clipboard and click on “Create”. We’ll parse the data and save the Project.</span>
                    <tinymce className="body_content" :height="330+'px'" @textareaInput="createRequirementClipBoardvalue" :toolbar-required="false" :auto-resize="false"></tinymce>
                    <a @click="openCreateProject">I’ll Manually Add the Project</a>
                    <div class="cr-error-clipBoardtext">Please write or paste anything on the clipboard to create</div>
                </div>
            </div>
        </template>
        <template slot="modal-footer" v-if="!showClipBoard">
            <ob-button type="secondary" @click="closeModal">Close</ob-button>
        </template>
        <template slot="modal-footer" v-else>
            <ob-button type="secondary" @click="closeClipBoardModal">Cancel</ob-button>
            <ob-button type="primary" :disabled="jobDescription == ''" @click="parseClipBoard">Create</ob-button>
        </template>
    </ob-modal2>
</template>
<script>
    import tinymce from "@/Components/tinymce.vue";
    import c from 'Vue/Core/constants.js'
    export default{
        props:['openModal','istaxOnboard', ],
        // 'MasterProjects'
        components: {
            "tinymce": tinymce,
            
        },
        data(){
            return{
                'isModalOpen':'',
                showClipBoard:false,
                jobDescription:'',
                createRequirementclipboard:''
            }
        },
        created(){
            this.isModalOpen = this.openModal
        },
        watch:{
            openModal(val){
                this.isModalOpen = val
            },
            isModalOpen(val){
                this.showClipBoard = false
                this.$emit('update:openModal',val)
            }
        },
        computed:{
            getOnboardId(){
                return this.$store.getters.getOnboardId
            },
            getCurrentStage(){
                return this.$store.getters.getCurrentStage
            },
             consultantDetails() {
                return this.$store.getters.getConsultantDetails
            }
        },
        methods:{
            formrequirement(){
                 this.$router.push({path:'/add-project',query:{tax:this.istaxOnboard,ConsulatntId:this.$route.params.id,type:this.$route.params.type,workpermit:this.$route.query.workpermit,JobId:this.$route.query.jobId}});
                 //this.$router.push({path: 'job-information/create-project',query:{onboardId:this.getOnboardId,stage:this.getCurrentStage}})
            },
            closeModal(){
                this.isModalOpen = false
            },
            closeClipBoardModal(){
                this.isModalOpen = false
                this.showClipBoard = false
            },
            createRequirementClipBoardvalue(val){
                 this.jobDescription = val
            },
            parseClipBoard(){
              let params = {
                    "clipBoardtext": this.jobDescription,
              }
              this.isModalOpen = false
              this.$loading({'loadingText': 'Loading...'})
              ajax.post(`/Job/JobCreateFromClipBoard?employeeOrgId=${this.loggedInUserObj.orgId}`,params,(res) => {
                    if(res.data.State){
                        this.$loading({}).close();
                        this.createRequirementclipboard = res.data.Job;

                        var tempPid = res.data.Job.Id
                        this.$store.commit('updateSelectedJob',res.data.Job.Id)
                        this.updateRequirementsvalueToStore();
                        
                        if(this.MasterProjects == false) {
                            setTimeout(()=>{
                            this.$router.push({path:'/add-new-project',query:{projectid:tempPid,isNewProject:true,consultantid:this.$route.params.id,tax:this.$route.query.tax,type:this.$route.params.type,workpermit:this.$route.query.workpermit,JobId:this.$route.query.jobId}});                  
                            },1000)
                        }
                        else
                        {
                            setTimeout(()=>{
                                this.$router.push({path:'/add-new-project',query:{projectid:tempPid,isNewProject:true}});                  
                            },1000)
                        }
                    }
                    else{
                        this.$message({
                          type: 'error',
                          message: res.data.Message
                          })
                          this.$loading({}).close()
                         }
                });

            },
            openCreateProject(){
                this.isModalOpen = false ;    
                if(this.MasterProjects == false) {            
                    var taxTermData = ''
                    if(this.istaxOnboard != "" && this.istaxOnboard !=undefined && this.istaxOnboard !=null){
                        taxTermData = this.istaxOnboard
                    }
                    else{
                        taxTermData = this.consultantDetails.HireType
                    }
                    // setTimeout(()=>{
                    //     this.$router.push({path:'/add-project',query:{tax:taxTermData,ConsulatntId:this.$route.params.id,type:this.$route.params.type,workpermit:this.$route.query.workpermit,JobId:this.$route.query.jobId}});                  
                    // },1000)

                    //setTimeout(()=>{
                        this.$router.push({name:'/add-new-project',
                        query:{
                            // consultantid:this.$route.params.id,
                            // tax:taxTermData,type:this.$route.params.type,
                            // workpermit:this.$route.query.workpermit,
                            // JobId:this.$route.query.jobId
                            }});                  
                  //  },)
                }
                else
                 {
                //     let url = `${c.APPLICATIONBASEURL}/app/add-new-project`;
                //     window.open(url,"_self");
                this.$router.push({name:'add-new-project',
                        query:{
                            // consultantid:this.$route.params.id,
                            // tax:taxTermData,type:this.$route.params.type,
                            // workpermit:this.$route.query.workpermit,
                            // JobId:this.$route.query.jobId
                            }});           
                }
                //  let url = `${c.APPLICATIONBASEURL}/app/add-new-project?ConsultantId=${this.$route.params.id}`;
                // window.open(url,"_self");
            },
            updateRequirementsvalueToStore(){
                
                // if(this.createRequirementclipboard.ApprovedAM.Contact != null){
                //      this.$store.commit('updateRequirementsField', { field: 'AcntManager', value: this.createRequirementclipboard.ApprovedAM.Contact.Name})
                // }
                // else{
                //      this.$store.commit('updateRequirementsField', { field: 'AcntManager', value:''})
                // }
                // if(this.createRequirementclipboard.ForOrganization != null){ 
                //     if(this.createRequirementclipboard.ForOrganization.Address != null){
                //         this.$store.commit('updateRequirementsField', { field: 'ZipCode', value: this.createRequirementclipboard.ForOrganization.Address.Zip })
                //         this.$store.commit('updateRequirementsField', { field: 'Address', value: this.createRequirementclipboard.ForOrganization.Address.Address1 })
                //     }
                // }
                //else if(this.createRequirementclipboard.ForOrganization.Address == null){
                //    this.$store.commit('updateRequirementsField', { field: 'ZipCode', value: '' })
                //    this.$store.commit('updateRequirementsField', { field: 'Address', value: '' })
                //}
                // if(this.createRequirementclipboard.OpenPosition != 0){
                //     this.$store.commit('updateRequirementsField', { field: 'OpenPositions', value: this.createRequirementclipboard.OpenPosition })
                // }
                // if(this.createRequirementclipboard.MinExperience != 0){
                //     this.$store.commit('updateRequirementsField', { field: 'MinExperience', value: this.createRequirementclipboard.MinExperience })
                // }
                // if(this.createRequirementclipboard.MaxExperience != 0){
                //     this.$store.commit('updateRequirementsField', { field: 'MaxExperience', value: this.createRequirementclipboard.MaxExperience })
                // }
                // if(this.createRequirementclipboard.MinProjectCount != 0){
                //     this.$store.commit('updateRequirementsField', { field: 'MinimumProjects', value: this.createRequirementclipboard.MinProjectCount })
                // }
                if(this.createRequirementclipboard.MinDuration != 0){
                    this.$store.commit('updateRequirementsField', { field: 'Duration', value: this.createRequirementclipboard.MinDuration })
                }
                if(this.createRequirementclipboard.StartDate != '' && this.createRequirementclipboard.StartDate != null){
                    this.$store.commit('updateRequirementsField', { field: 'StartDate', value: this.createRequirementclipboard.StartDate})
                }
                if(this.createRequirementclipboard.EmploymentType != '' && this.createRequirementclipboard.EmploymentType != null){
                    this.$store.commit('updateRequirementsField', { field: 'TaxTerms', value: this.createRequirementclipboard.EmploymentType })
                }
                if (this.createRequirementclipboard.Location != '' && this.createRequirementclipboard.Location != null) {
                    this.$store.commit('updateRequirementsField', { field: 'Location', value: this.createRequirementclipboard.Location })
                }
                this.$store.commit('updateRequirementsField', { field: 'Client', value: this.createRequirementclipboard.ForOrganization.Id})
                this.$store.commit('updateRequirementsField', { field: 'JobTitle', value: this.createRequirementclipboard.Name})
                this.$store.commit('updateRequirementsField', { field: 'RequirementId', value: this.createRequirementclipboard.RequirementId })
                this.$store.commit('updateRequirementsField', { field: 'NoPreference', value: this.createRequirementclipboard.AllowRepost })
                this.$store.commit('updateRequirementsField', { field: 'WorkPermit', value: this.createRequirementclipboard.workpermit })
                this.$store.commit('updateRequirementsField', { field: 'EducationQual', value: this.createRequirementclipboard.Qualification })
                this.$store.commit('updateRequirementsField', { field: 'Sponsorship', value: this.createRequirementclipboard.IsSponsership })
                this.$store.commit('updateRequirementsField', { field: 'JobDescription', value: this.createRequirementclipboard.Description })
                this.$store.commit('updateRequirementsField', { field: 'KeySkills', value: this.createRequirementclipboard.KeyTags })
                this.$store.commit('updateRequirementsField', { field: 'TechCategory', value: this.createRequirementclipboard.Technology.Id })
                this.$store.commit('updateRequirementsField', { field: 'TechSubCategory', value: this.createRequirementclipboard.SubTechnology.Id })
                this.$store.commit('updateRequirementsField', { field: 'JobId', value: this.createRequirementclipboard.Id })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .popup_requiremt-clip{
       // padding: 10px 0px;
    font-size: 12px;
    span{
        color: #143361;
        padding:5px 0px;
        display:block;
    }
     a{
         padding:5px 0px;
     }
    }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/ESSProjects/CreateProjectPopup.vue